import { SystemTypeResource } from '../resources';
import { SystemType } from './system_type';
import ImsObjectCollection from './ims_object_collection.service';
import { IIntervalService } from 'angular';
import { StartupRegistry } from 'app/startup/registry/registry';
import { ILocalStorageService } from 'angular-local-storage';
import { filter } from 'lodash';

/**
 * @ngdoc service
 * @name ims.shared.data.service:SystemTypeCollection
 * @description
 * A collection of ims SystemType objects. It handles loading and refreshing data.
 * @ngdoc event
 * @name ims.shared.data.service:SystemTypeCollection#SystemTypeCollection:Changed
 * @eventOf ims.shared.data.service:SystemTypeCollection
 * @eventType emit on root scope
 * @description
 * Emitted when the SystemTypeCollection is changed/updated.
 *
 * @param {Object} angularEvent Synthetic event object.
 */
export class SystemTypeCollection extends ImsObjectCollection<SystemType> {
    constructor(
        startUpRegistry: StartupRegistry,
        localStorageService: ILocalStorageService,
        $interval: IIntervalService,
    ) {
        super(startUpRegistry, localStorageService, $interval, SystemTypeResource, SystemType);
    }

    getAllSelectableAsArray() {
        return filter(this.getAllAsArray(), { selectable: true });
    }
}
